export default __webpack_public_path__ + "static/media/gallery_01.98a59498.jpg";